import LoginSettings from 'components/LoginSettings';

export default LoginSettings;
